import { render, staticRenderFns } from "./bookPinglun.vue?vue&type=template&id=6be4a7bf&scoped=true"
import script from "./bookPinglun.vue?vue&type=script&lang=js"
export * from "./bookPinglun.vue?vue&type=script&lang=js"
import style0 from "./bookPinglun.vue?vue&type=style&index=0&id=6be4a7bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4a7bf",
  null
  
)

export default component.exports